import { clsx } from 'clsx';
import { EntityDisplayConfigField } from '../../../interfaces/entity-display-config';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { Icon } from '../../../../icon/Icon';

export function EntityDisplayConfigValue({
  field,
  className,
  containerClassName,
  showHelperText = true,
  usePreviousValue = false
}: {
  field: EntityDisplayConfigField;
  className?: string;
  containerClassName?: string;
  showHelperText?: boolean;
  usePreviousValue?: boolean;
}) {
  const id = `${field.name}-value`;

  return (
    <div className={clsx('center-flex-row', containerClassName)}>
      <Tooltip dataId={id} title={field.value} enableOnTextOverflow>
        <div className='text-ellipsis d-inline-flex'>
          <span data-id={id} className={clsx('text-medium text-ellipsis', className)}>
            &nbsp;{usePreviousValue ? field.previousValue : field.value}
          </span>
        </div>
      </Tooltip>

      {showHelperText && field.HelperText ? (
        <Tooltip dataId={`${id}-help`} title={field.HelperText}>
          <Icon
            name='info'
            className={clsx('ml-1 text-secondary', className)}
            dataId={`${id}-help`}
            style={{ marginTop: -2 }}
          />
        </Tooltip>
      ) : null}
    </div>
  );
}
